import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearThreadToReply,
  selectThreadToReply,
} from '../../../store/slices/replyContextSlice';
import { sanitizeInput } from '../../../utils/sanitize';
import { Author } from '../../pieces/Author';
import { ContentBody } from '../../pieces/ContentBody';
import { useCreateCommentMutation } from '../../../store/api/commentApi';
import { Dialog } from '../../../layouts/Dialog';
import { Button } from '../../pieces/Button';

export function AddCommentDialog() {
  const [createComment, { isLoading: addingComment }] =
    useCreateCommentMutation();

  const dispatch = useDispatch();
  const [isShown, setIsShown] = useState(false);
  const [input, setInput] = useState('');
  const threadContext = useSelector(selectThreadToReply);
  const clean = sanitizeInput(input);
  const canSave = input !== '' && input !== '&nbsp' && !addingComment;

  const handleInput = (e) => {
    setIsShown(true);
    setInput(e.target.innerHTML);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createComment({
        threadId: threadContext.id,
        comment: clean,
      });

      document.getElementById('commentInputDialog').innerHTML = '';
      document.getElementById('addCommentDialog').close();
    } catch (err) {
      // eslint-disable-next-line no-alert
      alert(err.message);
    }
    dispatch(clearThreadToReply());
  };

  return (
    <Dialog dialogId="addCommentDialog">
      <div className="not-prose fixed top-[10vh] left-0 right-0 mx-auto grid max-h-[90vh] w-[90vw] max-w-md place-items-center rounded-2xl bg-gray-100 p-4 dark:bg-gray-900 md:p-8">
        <div className="w-full">
          <p className="mb-2 text-sm">
            <Author userId={threadContext.ownerId} /> posted:
          </p>
          <h4 className="font-semibold leading-5">
            {threadContext.title.length >= 30
              ? threadContext.title.substring(0, 29).concat('...')
              : threadContext.title}
          </h4>
          <div className="mt-2 text-sm">
            <ContentBody
              text={
                threadContext.body.length >= 100
                  ? threadContext.body.substring(0, 99).concat('...')
                  : threadContext.body
              }
            />
          </div>
        </div>
        <form onSubmit={handleSubmit} className="mt-4 w-full">
          <legend className="mb-4 text-sm">Your reply:</legend>
          <div className="max-h-[60vh] px-2">
            <div
              id="commentInputDialog"
              contentEditable
              value={input}
              suppressContentEditableWarning
              onInput={handleInput}
              className="mb-4 max-h-[40vh] overflow-auto rounded-2xl px-4 py-2 [word-break:break-word] before:text-gray-900/50 empty:before:[content:'Add_a_reply...'] dark:before:text-gray-100/60"
            />
          </div>
          {isShown ? (
            <div>
              <div className="flex flex-row-reverse items-center gap-2">
                <Button
                  size="base"
                  variant="primary"
                  type="submit"
                  disabled={!canSave}
                >
                  {addingComment ? 'Submitting...' : 'Submit'}
                </Button>

                <Button
                  size="base"
                  variant="tertiary"
                  type="button"
                  onClick={() => {
                    document.getElementById('commentInputDialog').innerHTML =
                      '';
                    setIsShown(false);
                    document.getElementById('addCommentDialog').close();
                    dispatch(clearThreadToReply());
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            ''
          )}
        </form>
      </div>
    </Dialog>
  );
}
